export default "__VITE_ASSET__247aea68__"